import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import initTreeView from '../../../services/initTreeView';
import { getApiData } from '../../../services/apiService';
import { BsCheckCircleFill, BsWrenchAdjustable   } from "react-icons/bs";
import { GiBroom } from "react-icons/gi";
import { BsCalendar2CheckFill } from "react-icons/bs";
import { VscSignOut } from "react-icons/vsc";
import { GiSandsOfTime } from "react-icons/gi";
import { TbCalendarX } from "react-icons/tb";
import { TbCalendarQuestion } from "react-icons/tb";
import { TbCalendarCheck } from "react-icons/tb";
import { RiCalendarCheckFill } from "react-icons/ri";
 
export default function ShipBookingDashboard (){
    const isMounted = useRef(false);
    const [loading, setLoading] = useState(0);
    const navigate = useNavigate();
    const [widget_data, setWidgetData] = useState({
        // "OK": 0,
        // "SERVICE": 0,
        // "OUT": 0,
        // "CLEAN DUE": 0,
        // "CLEANED": 0,
        "pending": 0,
        "confirmed": 0,
        "paid": 0,
        "cancelled": 0,
        "refunded": 0
    });

   
    useEffect(() => {// 2. Check the guard
        //if (isMounted.current) {
        //return; 
       // }

        //isMounted.current = true;
        
        initTreeView()
        //Mounted

        setLoading(1)
        async function fetchWidgetData(){
            let filter = '?store_id='+helpers.getStoreID()+'&'
            filter = filter.slice(0, -1)

            const endpoint = helpers.createShipBookingHubUrl('booking/stats')
            const res = await getApiData(endpoint)
            if(res.status === 'error'){
                setLoading(0)
                Swal.fire({
                    text: res.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
            }
            else{
                console.log('res', res)
                setWidgetData(res)
                setLoading(0)
            }
        }

        fetchWidgetData()
    }, []);

    return (
        <>
        <Layout page_title="Booking Dashboard" menu="home" breadcrumbs={false}>
                <div className="content">
                    <div className="container-fluid"  style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>

                        {/* <h5>Insights</h5> */}
                        <div className="row">
                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/ship-booking/bookings?status=2">
                                    <span className="info-box-icon bg-success"><TbCalendarCheck /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text mb-0 text-dark text-uppercase">Confirmed</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.confirmed || 0}</h5>
                                        <small className='text-muted'>Booking(s)</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/ship-booking/bookings?status=1">
                                    <span className="info-box-icon bg-warning"><TbCalendarQuestion  /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark text-uppercase">Pending</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.pending || 0}</h5>
                                        <small className='text-muted'>Booking(s)</small>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/ship-booking/bookings?status=4">
                                    <span className="info-box-icon bg-danger"><TbCalendarX   /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark text-uppercase">Cancelled</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.cancelled || 0}</h5>
                                        <small className='text-muted'>Booking(s)</small>
                                    </div>
                                </Link>
                            </div>

                            {/* <div className="col-sm-6 col-md-4 col-lg-3 d-flex">
                                <Link className="info-box pointer" to="/ship-booking/bookings?status=5">
                                    <span className="info-box-icon bg-primary"><TbCalendarX  /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text text-dark text-uppercase">Refunded</span>
                                        <h5 className="info-box-number mb-0 text-dark">{widget_data?.refunded || 0}</h5>
                                        <small className='text-muted'>Booking(s)</small>
                                    </div>
                                </Link>
                            </div> */}
                        </div>


                    </div>{/* /.container-fluid */}
                </div>

        </Layout>
        </>
    )
}